$(function() {

  var $navItem = $('.navigation__item a[data-subnavigation]');

  $navItem.each(function() {
    var $this = $(this),
        $subTarget;

    if ($this.data('subnavigation').length > 0) {

      $subTarget = $('#' + $this.data('subnavigation'));

      $this.hover(function() {
        $subTarget.addClass('active');
        $('.cart-box').removeClass('active');
      }, function() {
        $subTarget.removeClass('active');
      });

    } else {
      return false;
    }

  });

});